<template>
    <div class="home">

        <HelloWorld msg="Welcome to Your Vue.js App" />
        <HomeContent />
        <Contact />
    </div>
</template>

<script>
    // @ is an alias to /src
    import HelloWorld from "@/components/HelloWorld.vue";
    import HomeContent from "@/components/HomeContent.vue";
    import Contact from "@/components/Contact.vue";

    export default {
        name: "home",
        components: {
            HelloWorld,
            HomeContent,
            Contact
        },
        metaInfo: {
            title: 'Best Solution of Technology, Big Data, Artificial Intelligence, Consult, Online Marketing',
            titleTemplate: '%s - Exito Group Co.,Ltd',
            meta:[
              { name:'description', content:'We implement Big Data Program to help your business, Big Data Program combines automation technology, analyze data and prepare a solutions for your client.' },
               // OpenGraph data (Most widely used)
              {property: 'og:title', content: 'Best Solution of Technology, Big Data, Artificial Intelligence, Consult, Online Marketing ← Exito Group Co.,Ltd'},
              {property: 'og:site_name', content: 'https://exitogroup.co.th'},
              // The list of types is available here: http://ogp.me/#types
              {property: 'og:type', content: 'website'},
              // Should the the same as your canonical link, see below.
              {property: 'og:url', content: 'https://exitogroup.co.th'},
              {property: 'og:image', content: 'https://exitogroup.co.th/img/logo.png'},
              // Often the same as your meta description, but not always.
              {property: 'og:description', content: 'We implement Big Data Program to help your business, Big Data Program combines automation technology, analyze data and prepare a solutions for your client.'},

              // Twitter card
              {name: 'twitter:card', content: 'summary'},
              {name: 'twitter:site', content: 'https://exitogroup.co.th'},
              {name: 'twitter:title', content: 'Best Solution of Technology, Big Data, Artificial Intelligence, Consult, Online Marketing ← Exito Group Co.,Ltd'},
              {name: 'twitter:description', content: 'We implement Big Data Program to help your business, Big Data Program combines automation technology, analyze data and prepare a solutions for your client.'},
              // Your twitter handle, if you have one.
              {name: 'twitter:creator', content: '@alligatorio'},
              {name: 'twitter:image:src', content: 'https://exitogroup.co.th/img/logo.png'},

              // Google / Schema.org markup:
              {itemprop: 'name', content: 'Best Solution of Technology, Big Data, Artificial Intelligence, Consult, Online Marketing ← Exito Group Co.,Ltd'},
              {itemprop: 'description', content: 'We implement Big Data Program to help your business, Big Data Program combines automation technology, analyze data and prepare a solutions for your client.'},
              {itemprop: 'image', content: 'https://exitogroup.co.th/img/logo.png'}
            ],
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    };
</script>
